import React from 'react';

const HeroSection = () => {
  return (
    <div className="font-[sans-serif] max-w-full mx-auto px-4">
      <div className="grid md:grid-cols-2 items-center md:gap-10 gap-6">
        <div className="max-md:order-1 max-md:text-center">
          {/* Styled text with rgb(8, 64, 88) color */}
          <p className="mt-4 text-sm font-bold text-[rgb(8, 64, 88)]">
            <span className="rotate-90 inline-block mr-2 mb-2">|</span> ALL IN ONE INTERVIEW SCHEDULER
          </p>
          {/* Header text in rgb(8, 64, 88) for readability */}
          <h2 className="text-[rgb(8, 64, 88)] md:text-5xl text-3xl font-extrabold mb-4 md:!leading-[55px]">
            Streamline your hiring process with ease
          </h2>
          {/* Description text in white for better contrast on background */}
          <p className="mt-5 text-base text-white leading-relaxed">
            Schedule interviews, assess candidates, and make data-driven decisions effortlessly.
            Experience seamless coordination and faster hiring today.
          </p>

          {/* Sleek buttons with muted styling using rgb(8, 64, 88) */}
          <div className="mt-10 flex justify-center space-x-4">
            <button className="border border-[rgb(8, 64, 88)] text-[rgb(8, 64, 88)] px-6 py-2 rounded-lg hover:bg-[rgb(8, 64, 88)] hover:text-white transition duration-300">
              Schedule an Interview
            </button>
            <button className="border border-[rgb(8, 64, 88)] text-[rgb(8, 64, 88)] px-6 py-2 rounded-lg hover:bg-[rgb(8, 64, 88)] hover:text-white transition duration-300">
              View Candidates
            </button>
            <button className="border border-[rgb(8, 64, 88)] text-[rgb(8, 64, 88)] px-6 py-2 rounded-lg hover:bg-[rgb(8, 64, 88)] hover:text-white transition duration-300">
              Explore Features
            </button>
          </div>
        </div>

        {/* Increased image height */}
        <div className="md:h-[600px] w-full p-2">
          <img src="https://readymadeui.com/management-img.webp" className="w-full h-full object-cover rounded-lg" alt="Interview Scheduling" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
